import { useState, useEffect } from 'react';
import { supabase } from '../supabase';
import { C, fmt, audit, getComprobanteUrl } from '../constants';
import { Btn, Card, NivelBadge, ProximamenteBadge, Toast } from '../components/Atoms';
import { DetalleTanda } from './DetalleTanda';
import { TablaNiveles } from '../components/Landing';
import LOGO from '../assets/logo';

// ─── MENÚ HAMBURGUESA ──────────────────────────────────────
function MenuHamburguesa({ onClose, vistaActual, onNavegar, onSalir, usuario }) {
  const items = [
    { id: 'tandas', icon: '🤝', label: 'Mis tandas' },
    { id: 'explorar', icon: '🔍', label: 'Explorar' },
    { id: 'pagos', icon: '💸', label: 'Mis pagos' },
    { id: 'asistente', icon: '💬', label: 'Asistente' },
    { id: 'referidos', icon: '👥', label: 'Referidos', proximamente: true },
    { id: 'perfil', icon: '👤', label: 'Mi perfil' },
    { id: 'faq', icon: '❓', label: 'Preguntas frecuentes' },
    ...(usuario?.rol === 'admin' ? [{ id: 'admin', icon: '⚙️', label: 'Panel Admin' }] : []),
  ];

  return (
    <div style={{ position: 'fixed', inset: 0, zIndex: 500, display: 'flex' }}>
      <div onClick={onClose} style={{ position: 'absolute', inset: 0, background: 'rgba(0,0,0,0.4)' }} />
      <div style={{ position: 'relative', width: 280, background: C.white, height: '100%', display: 'flex', flexDirection: 'column', boxShadow: '4px 0 20px rgba(0,0,0,0.15)' }}>
        <div onClick={() => window.location.reload()} style={{ background: `linear-gradient(135deg, ${C.primary}, ${C.accent})`, padding: '48px 20px 24px', cursor: 'pointer' }}>
          <div style={{ fontSize: 20, fontWeight: 900, color: C.white }}>TandaClick</div>
          <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.7)', marginTop: 4 }}>Tu plataforma de ahorro</div>
        </div>
        <div style={{ flex: 1, padding: '16px 0', overflowY: 'auto' }}>
          {items.map(item => (
            <div key={item.id} onClick={() => { if (item.proximamente) return; onNavegar(item.id); onClose(); }}
              style={{
                display: 'flex', alignItems: 'center', gap: 14, padding: '14px 20px',
                background: vistaActual === item.id ? C.primaryLt : 'transparent',
                cursor: item.proximamente ? 'default' : 'pointer', borderLeft: vistaActual === item.id ? `3px solid ${C.primary}` : '3px solid transparent',
                opacity: item.proximamente ? 0.5 : 1,
              }}>
              <span style={{ fontSize: 20 }}>{item.icon}</span>
              <span style={{ fontSize: 14, fontWeight: vistaActual === item.id ? 800 : 600, color: vistaActual === item.id ? C.primary : C.text }}>{item.label}</span>
              {item.id === 'explorar' && <span style={{ marginLeft: 'auto', background: C.successLt, color: C.success, fontSize: 10, fontWeight: 700, padding: '2px 8px', borderRadius: 99 }}>Nuevo</span>}
              {item.proximamente && <span style={{ marginLeft: 'auto', background: C.warningLt, color: C.warning, fontSize: 10, fontWeight: 700, padding: '2px 8px', borderRadius: 99 }}>Próximamente</span>}
            </div>
          ))}
        </div>
        <div style={{ padding: '16px 20px', borderTop: `1px solid ${C.gray200}` }}>
          <button onClick={onSalir} style={{ background: 'none', border: 'none', color: C.danger, fontSize: 14, fontWeight: 700, cursor: 'pointer', fontFamily: "'Plus Jakarta Sans', sans-serif", display: 'flex', alignItems: 'center', gap: 8 }}>
            <span>🚪</span> Cerrar sesión
          </button>
        </div>
      </div>
    </div>
  );
}

// ─── NAVBAR APP ────────────────────────────────────────────
function NavbarApp({ onMenuOpen, titulo, onHome, notificaciones = 0, onNotificaciones }) {
  return (
    <div style={{ background: C.white, borderBottom: `1px solid ${C.gray200}`, padding: '0 16px', height: 64, display: 'flex', alignItems: 'center', justifyContent: 'space-between', position: 'sticky', top: 0, zIndex: 100, boxShadow: '0 1px 4px rgba(0,0,0,0.06)' }}>
      <img src={LOGO} alt="TandaClick" onClick={onHome} style={{ height: 36, width: 'auto', objectFit: 'contain', cursor: onHome ? 'pointer' : 'default' }} />
      {titulo && <div style={{ fontSize: 15, fontWeight: 700, color: C.textMd }}>{titulo}</div>}
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        {onNotificaciones && (
          <button onClick={onNotificaciones} style={{ background: C.gray100, border: `1px solid ${C.gray200}`, cursor: 'pointer', position: 'relative', padding: '9px 10px', borderRadius: 10 }}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={C.text} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/>
            </svg>
            {notificaciones > 0 && (
              <span style={{ position: 'absolute', top: -2, right: -2, background: '#DC2626', color: '#fff', fontSize: 9, fontWeight: 800, width: 16, height: 16, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{notificaciones}</span>
            )}
          </button>
        )}
        <button onClick={onMenuOpen} style={{ background: C.gray100, border: `1px solid ${C.gray200}`, cursor: 'pointer', padding: '10px 12px', display: 'flex', flexDirection: 'column', gap: 5, borderRadius: 10 }}>
          {[0, 1, 2].map(i => <div key={i} style={{ width: 24, height: 2.5, background: C.text, borderRadius: 99 }} />)}
        </button>
      </div>
    </div>
  );
}

// ─── PANTALLA PRÓXIMAMENTE ─────────────────────────────────
function Proximamente({ icon, titulo, descripcion, onMenu, onHome }) {
  return (
    <div style={{ minHeight: '100vh', background: C.gray50, fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
      <NavbarApp onMenuOpen={onMenu} titulo={titulo} onHome={onHome} />
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '80px 40px', textAlign: 'center' }}>
        <div style={{ fontSize: 64, marginBottom: 20 }}>{icon}</div>
        <div style={{ fontSize: 20, fontWeight: 900, color: C.text, marginBottom: 8 }}>{titulo}</div>
        <ProximamenteBadge />
        <div style={{ fontSize: 14, color: C.textMd, lineHeight: 1.7, marginTop: 16, maxWidth: 280 }}>{descripcion}</div>
      </div>
    </div>
  );
}

// ─── GUÍA DE PRIMEROS PASOS ────────────────────────────────
function PrimerosPasos() {
  const [expandido, setExpandido] = useState(false);
  const pasos = [
    { num: '1', titulo: 'Recibe la CLABE', desc: 'Cada semana verás la CLABE para depositar en la sección de tu tanda.' },
    { num: '2', titulo: 'Deposita por SPEI', desc: 'Haz una transferencia desde tu banco por el monto exacto de tu aportación.' },
    { num: '3', titulo: 'Sube tu comprobante', desc: 'Toma foto de la confirmación y súbela en la app. El admin la verifica en 24 hrs.' },
    { num: '4', titulo: 'Cobra cuando es tu turno', desc: 'Cuando llegue tu semana, deposita primero y recibes tu tanda completa.' },
  ];

  return (
    <div style={{ background: C.white, border: `1.5px solid ${C.gray200}`, borderRadius: 16, marginBottom: 16, overflow: 'hidden' }}>
      <button onClick={() => setExpandido(v => !v)} style={{
        width: '100%', background: 'none', border: 'none', padding: '16px 18px',
        display: 'flex', justifyContent: 'space-between', alignItems: 'center',
        cursor: 'pointer', fontFamily: "'Plus Jakarta Sans', sans-serif",
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <span style={{ fontSize: 22 }}>📖</span>
          <div style={{ textAlign: 'left' }}>
            <div style={{ fontSize: 15, fontWeight: 900, color: C.text }}>¿Cómo funciona?</div>
            <div style={{ fontSize: 12, color: C.textLt, marginTop: 1 }}>Guía de primeros pasos</div>
          </div>
        </div>
        <span style={{ fontSize: 20, color: C.gray400, transition: 'transform 0.2s', transform: expandido ? 'rotate(180deg)' : 'none', fontWeight: 300 }}>▾</span>
      </button>

      {expandido && (
        <div style={{ padding: '0 18px 18px' }}>
          {pasos.map((p, i) => (
            <div key={i} style={{ display: 'flex', gap: 14, padding: '12px 0', borderTop: `1px solid ${C.gray100}` }}>
              <div style={{ width: 32, height: 32, borderRadius: '50%', background: C.primary, color: C.white, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 14, fontWeight: 900, flexShrink: 0 }}>{p.num}</div>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: 14, fontWeight: 800, color: C.text, marginBottom: 3 }}>{p.titulo}</div>
                <div style={{ fontSize: 13, color: C.textMd, lineHeight: 1.6 }}>{p.desc}</div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

// ─── PREGUNTAS FRECUENTES APP ──────────────────────────────
const FAQ_CATEGORIAS = [
  {
    id: 'inicio', icon: '🚀', label: 'Primeros pasos',
    preguntas: [
      { q: '¿Cómo funciona una tanda?', a: 'Cada semana un participante diferente recibe el total acumulado del grupo. Por ejemplo, si son 10 personas aportando $200, cada semana alguien cobra $2,000.' },
      { q: '¿Cómo me uno a una tanda?', a: 'Entra a la sección "Explorar" y busca la tanda que más te convenga según la frecuencia de pago: semanal, quincenal o mensual. Las opciones disponibles se muestran de acuerdo a tu nivel y score de confianza. Tu primera tanda siempre será con el equipo de TandaClick, una vez que la completes, podrás acceder a más opciones.' },
      { q: '¿Cuándo me toca cobrar?', a: 'Al inscribirte a una tanda se realiza un sorteo que asigna tu número de turno. Dependiendo de si la tanda es semanal, quincenal o mensual, tu turno determina exactamente en qué fecha recibirás tu dinero. Todo queda visible desde la pantalla de tu tanda.' },
      { q: '¿Qué es el depósito de seguridad?', a: 'Al unirte a tu primera tanda como nivel Bronce, se te solicita un depósito de seguridad equivalente a una aportación. Este depósito te será devuelto al completar exitosamente la tanda. Su función es garantizar el compromiso de todos los participantes.' },
    ]
  },
  {
    id: 'pagos', icon: '💸', label: 'Pagos y depósitos',
    preguntas: [
      { q: '¿Cómo hago mi depósito?', a: 'Tienes dos opciones:\n\n📱 Transferencia SPEI: Haz la transferencia desde tu banco a la CLABE que aparece en tu tanda, toma una captura de pantalla de la confirmación y súbela en la app: entra a tu tanda, toca "Seleccionar comprobante", elige la foto de tu comprobante y da click en "Confirmar y enviar".\n\n🏪 Depósito en OXXO: Ve a cualquier OXXO, deposita el monto exacto con la referencia de tu tanda, pide tu ticket impreso, tómale una foto y súbelo en la app siguiendo los mismos pasos.' },
      { q: '¿Qué pasa si no subo mi comprobante?', a: 'Tu pago aparecerá como "Pendiente" hasta que lo subas. Si no pagas a tiempo, afecta tu score de confianza y puede resultar en reporte al Buró de Crédito.' },
      { q: '¿Cuánto tiempo tarda en confirmarse mi pago?', a: 'El equipo de TandaClick verifica tu comprobante en menos de 24 horas. Recibirás una notificación cuando esté confirmado.' },
      { q: '¿Qué hago si rechazaron mi comprobante?', a: 'La app te muestra el motivo del rechazo. Corrige el problema indicado (imagen borrosa, monto incorrecto, referencia equivocada, etc.) y sube uno nuevo.' },
    ]
  },
  {
    id: 'cobro', icon: '🏦', label: 'Cobrar mi tanda',
    preguntas: [
      { q: '¿Cuándo recibo mi tanda?', a: 'Cuando llegue tu turno y hayas depositado tu aportación correspondiente, TandaClick te envía el dinero según el método que elegiste al registrarte. Al inicio te preguntaremos cómo quieres recibir tu tanda: si eliges transferencia, llegará directo a tu cuenta bancaria; si eliges OXXO, recibirás un código QR para ir a cualquier OXXO del país y cobrar en efectivo.' },
      { q: '¿Tengo que pagar aunque ya cobré mi tanda?', a: 'Sí. Aunque ya recibiste tu tanda, debes seguir depositando cada semana para que los demás participantes también puedan cobrar la suya. Es el compromiso que hace funcionar la tanda para todos.' },
      { q: '¿Por qué me llegó menos de lo esperado?', a: 'TandaClick descuenta una comisión del 3% al momento de entregarte tu tanda. Por ejemplo, si tu tanda es de $2,000, recibirás $1,940.' },
    ]
  },
  {
    id: 'niveles', icon: '⭐', label: 'Niveles y score',
    preguntas: [
      { q: '¿Para qué sirven los niveles?', a: '', jsx: (
        <div>
          <div style={{ fontSize: 13, color: C.textMd, marginBottom: 14, lineHeight: 1.6 }}>Tu nivel define a qué tandas puedes acceder y qué beneficios tienes. Subes cumpliendo tandas y pagando a tiempo.</div>
          {[
            { icon: '🥉', nivel: 'Bronce', req: '0 - 19 puntos', color: '#92400E', bg: '#FEF3C7', monto: 'Hasta $500', adelanto: 'Sin acceso', extra: 'Nivel inicial', tandas: '0-1' },
            { icon: '🥈', nivel: 'Plata',  req: '20+ puntos (2 tandas)', color: '#374151', bg: '#F3F4F6', monto: 'Hasta $2,000', adelanto: 'Comision 12%', extra: 'Acceso a adelantos de tanda', tandas: '2+' },
            { icon: '🥇', nivel: 'Oro',    req: '50+ puntos (5 tandas)', color: '#B45309', bg: '#FEF9C3', monto: 'Hasta $5,000', adelanto: 'Comision 10%', extra: 'Beneficios exclusivos', tandas: '5+' },
            { icon: '💎', nivel: 'Platino', req: '80+ puntos (8 tandas)', color: '#1E40AF', bg: '#DBEAFE', monto: 'Sin limite', adelanto: 'Comision 8%', extra: 'Nivel maximo, acceso total', tandas: '8+' },
          ].map((n, i) => (
            <div key={i} style={{ background: n.bg, borderRadius: 12, padding: '12px 14px', marginBottom: 8, border: `1px solid ${n.color}22` }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
                <span style={{ fontSize: 22 }}>{n.icon}</span>
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: 14, fontWeight: 900, color: n.color }}>{n.nivel}</div>
                  <div style={{ fontSize: 12, color: n.color, fontWeight: 700, lineHeight: 1.5, opacity: 0.8 }}>{n.req}</div>
                </div>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 6 }}>
                <div style={{ background: 'rgba(255,255,255,0.7)', borderRadius: 8, padding: '6px 10px' }}>
                  <div style={{ fontSize: 10, color: C.textLt, marginBottom: 2 }}>APORTACIÓN EN TANDA</div>
                  <div style={{ fontSize: 12, fontWeight: 800, color: C.text }}>{n.monto}</div>
                </div>
                <div style={{ background: 'rgba(255,255,255,0.7)', borderRadius: 8, padding: '6px 10px' }}>
                  <div style={{ fontSize: 10, color: C.textLt, marginBottom: 2 }}>ADELANTOS</div>
                  <div style={{ fontSize: 12, fontWeight: 800, color: C.text }}>{n.adelanto}</div>
                </div>
              </div>
              <div style={{ fontSize: 12, color: C.textMd, marginTop: 8 }}>✓ {n.extra}</div>
            </div>
          ))}
          <div style={{ background: '#F0FDF4', border: '1px solid #BBF7D0', borderRadius: 10, padding: '10px 14px', marginTop: 4 }}>
            <div style={{ fontSize: 12, fontWeight: 800, color: '#166534', marginBottom: 4 }}>📊 Sistema de puntos</div>
            <div style={{ fontSize: 12, color: '#15803D', lineHeight: 1.8 }}>
              Cada tanda completada te da hasta 10 puntos.<br/>
              Pago a tiempo = 2 creditos · Pago con amonestacion = 1 credito<br/>
              Tu nivel sube automaticamente y nunca baja.
            </div>
          </div>
        </div>
      ) },
      { q: '¿Cómo subo de nivel?', a: 'Completando tandas. Cada tanda te da hasta 10 puntos segun que tan puntual fuiste. Pagar a tiempo vale el doble que pagar con amonestacion. Tu nivel sube automaticamente cuando alcanzas los puntos: Plata a los 20 pts, Oro a los 50 pts, Platino a los 80 pts.' },
      { q: '¿Mi nivel puede bajar?', a: 'No. Tu nivel nunca baja. Los puntos se acumulan con cada tanda completada. Si recibes amonestaciones, ganas menos puntos por esa tanda, pero tus puntos totales nunca se reducen.' },
      { q: '¿Por qué me pueden expulsar de la plataforma?', a: '', jsx: (
        <div>
          <div style={{ fontSize: 13, color: C.textMd, marginBottom: 12, lineHeight: 1.6 }}>TandaClick puede suspender o expulsar a un usuario en los siguientes casos:</div>
          {[
            { icon: '❌', texto: 'No realizar los pagos en los plazos establecidos de forma reiterada' },
            { icon: '🚫', texto: 'Subir comprobantes falsos o alterados' },
            { icon: '⚠️', texto: 'Intentar abandonar una tanda activa sin justificación' },
            { icon: '🔒', texto: 'Comportamiento fraudulento o suplantación de identidad' },
            { icon: '📢', texto: 'Acumular múltiples reportes negativos de otros participantes' },
            { icon: '📋', texto: 'Incumplir los Términos y Condiciones de la plataforma' },
          ].map((item, i) => (
            <div key={i} style={{ display: 'flex', gap: 10, alignItems: 'flex-start', padding: '8px 0', borderBottom: `1px solid ${C.gray100}` }}>
              <span style={{ fontSize: 16, flexShrink: 0, marginTop: 1 }}>{item.icon}</span>
              <span style={{ fontSize: 13, color: C.text, lineHeight: 1.6 }}>{item.texto}</span>
            </div>
          ))}
          <div style={{ background: '#FEF2F2', border: '1px solid #FECACA', borderRadius: 10, padding: '12px 14px', marginTop: 12 }}>
            <div style={{ fontSize: 13, fontWeight: 800, color: '#DC2626', marginBottom: 4 }}>⚠️ Consecuencias de la expulsión</div>
            <div style={{ fontSize: 12, color: '#7F1D1D', lineHeight: 1.7 }}>El depósito de seguridad puede ser retenido para compensar a los participantes afectados. Los usuarios expulsados quedan reportados al Buró de Crédito y no podrán volver a registrarse en TandaClick.</div>
          </div>
        </div>
      ) },
    ]
  },
  {
    id: 'adelantos', icon: '⚡', label: 'Adelantos',
    preguntas: [
      { q: '¿Qué es un adelanto de tanda?', a: 'Si necesitas tu dinero antes de que te toque cobrar, TandaClick puede adelantarte el monto completo de tu tanda. Pagas una comisión según tu nivel: Plata 12%, Oro 10%, Platino 8%.' },
      { q: '¿Quién puede pedir un adelanto?', a: 'Usuarios nivel Plata o superior. Los usuarios Bronce no tienen acceso a adelantos hasta completar su primera tanda.' },
      { q: '¿Cómo solicito un adelanto?', a: 'La opción de adelanto aparece automáticamente en la pantalla de tu tanda cuando tu score y comportamiento lo permiten. Si la ves disponible, solo selecciónala y confirma, el dinero llega a tu cuenta en minutos.' },
    ]
  },
];

function PreguntasFrecuentesApp({ onMenu, onHome }) {
  const [catActiva, setCatActiva] = useState('inicio');
  const [abierta, setAbierta] = useState(null);

  const cat = FAQ_CATEGORIAS.find(c => c.id === catActiva);

  return (
    <div style={{ minHeight: '100vh', background: C.gray50, fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
      <NavbarApp onMenuOpen={onMenu} titulo="Preguntas frecuentes" onHome={onHome} />
      <div style={{ padding: '16px 16px 80px' }}>

        {/* Tabs de categorías */}
        <div style={{ display: 'flex', gap: 8, overflowX: 'auto', paddingBottom: 4, marginBottom: 16, scrollbarWidth: 'none' }}>
          {FAQ_CATEGORIAS.map(c => (
            <button key={c.id} onClick={() => { setCatActiva(c.id); setAbierta(null); }} style={{
              flexShrink: 0, padding: '8px 14px', borderRadius: 99, border: 'none', cursor: 'pointer',
              background: catActiva === c.id ? C.primary : C.white,
              color: catActiva === c.id ? C.white : C.textMd,
              fontSize: 13, fontWeight: 700,
              border: catActiva === c.id ? 'none' : `1px solid ${C.gray200}`,
              fontFamily: "'Plus Jakarta Sans', sans-serif",
            }}>
              {c.icon} {c.label}
            </button>
          ))}
        </div>

        {/* Preguntas de la categoría activa */}
        <div>
          {cat.preguntas.map((p, i) => (
            <div key={i} onClick={() => setAbierta(abierta === i ? null : i)}
              style={{ background: C.white, border: `1px solid ${abierta === i ? C.primary : C.gray200}`, borderRadius: 14, marginBottom: 10, overflow: 'hidden', cursor: 'pointer', transition: 'border-color 0.2s' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px 18px', gap: 12 }}>
                <div style={{ fontSize: 14, fontWeight: 800, color: C.text, lineHeight: 1.4 }}>{p.q}</div>
                <div style={{ fontSize: 20, color: abierta === i ? C.primary : C.gray400, flexShrink: 0, transform: abierta === i ? 'rotate(45deg)' : 'none', transition: 'transform 0.2s' }}>+</div>
              </div>
              {abierta === i && (
                <div style={{ padding: '0 18px 18px' }}>
                  {p.jsx ? p.jsx : <div style={{ fontSize: 14, color: C.textMd, lineHeight: 1.8 }}>{p.a}</div>}
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Banner WhatsApp */}
        <div style={{ background: C.primaryLt, border: `1px solid ${C.primaryMd}`, borderRadius: 14, padding: '16px', marginTop: 8, textAlign: 'center' }}>
          <div style={{ fontSize: 14, fontWeight: 800, color: C.primary, marginBottom: 6 }}>¿No encontraste tu respuesta?</div>
          <div style={{ fontSize: 13, color: C.textMd, marginBottom: 12 }}>Nuestro asistente te responde en minutos por WhatsApp.</div>
          <button onClick={() => { window.location.href = 'https://wa.me/5214793915920?text=Hola%2C%20tengo%20una%20pregunta'; }}
            style={{ background: '#25D366', color: C.white, border: 'none', borderRadius: 10, padding: '12px 24px', fontSize: 14, fontWeight: 800, cursor: 'pointer', fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
            💬 Preguntar por WhatsApp
          </button>
        </div>
      </div>
    </div>
  );
}

// Mini FAQ para Mis Tandas (solo las más importantes)
function MiniFaq() {
  const [abierta, setAbierta] = useState(null);
  const preguntas = [
    { q: '¿Cómo hago mi depósito?', a: 'Copia la CLABE de tu tanda y haz una transferencia SPEI desde tu banco. Luego sube el comprobante en la app y el admin lo confirma en menos de 24 hrs.' },
    { q: '¿Cuándo me toca cobrar?', a: 'Tu turno está en la pantalla de la tanda. Si tienes el turno #3, cobras en la semana 3. Debes haber depositado tu aportación esa semana para recibir tu tanda.' },
    { q: '¿Tengo que pagar aunque ya cobré?', a: 'Sí, debes seguir pagando cada semana para que los demás puedan cobrar. Es lo que hace que la tanda funcione para todos.' },
    { q: '¿Qué es la comisión del 3%?', a: 'TandaClick descuenta el 3% del monto de tu tanda cuando la recibes. Es nuestra comisión por el servicio — no hay más cobros ocultos.' },
  ];

  return (
    <div style={{ marginTop: 24 }}>
      <div style={{ fontSize: 13, fontWeight: 800, color: C.textMd, marginBottom: 12, letterSpacing: 0.5, textTransform: 'uppercase' }}>Preguntas frecuentes</div>
      {preguntas.map((p, i) => (
        <div key={i} onClick={() => setAbierta(abierta === i ? null : i)}
          style={{ background: C.white, border: `1px solid ${abierta === i ? C.primary : C.gray200}`, borderRadius: 12, marginBottom: 8, overflow: 'hidden', cursor: 'pointer' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '14px 16px', gap: 10 }}>
            <div style={{ fontSize: 14, fontWeight: 700, color: C.text, lineHeight: 1.4 }}>{p.q}</div>
            <div style={{ fontSize: 18, color: abierta === i ? C.primary : C.gray400, flexShrink: 0, transform: abierta === i ? 'rotate(45deg)' : 'none', transition: 'transform 0.2s' }}>+</div>
          </div>
          {abierta === i && (
            <div style={{ padding: '0 16px 16px', fontSize: 13, color: C.textMd, lineHeight: 1.8 }}>{p.a}</div>
          )}
        </div>
      ))}
    </div>
  );
}

// ─── EXPLORAR ─────────────────────────────────────────────
const NIVEL_LIMITE = {
  'Bronce': 500, 'Plata': 2000, 'Oro': 5000, 'Platino': 5000,
};
const NIVEL_ORDEN = { 'Bronce': 0, 'Plata': 1, 'Oro': 2, 'Platino': 3 };
const NIVELES_FILTRO = ['Bronce', 'Plata', 'Oro', 'Platino'];
const MONTOS_FILTRO = [200, 300, 500, 1000, 1500, 2000, 2500, 3000];
const FRECUENCIAS = ['Semanal', 'Quincenal', 'Mensual'];

function Explorar({ usuario, onMenu, onHome }) {
  const [tandas, setTandas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filtroMonto, setFiltroMonto] = useState(null);
  const [filtroFrec, setFiltroFrec] = useState(null);
  const [filtroNivel, setFiltroNivel] = useState(null);
  const [toast, setToast] = useState({ msg: '', type: '' });
  const showToast = (msg, type = 'info') => { setToast({ msg, type }); setTimeout(() => setToast({ msg: '', type: '' }), 4000); };

  const nivelUsuario = usuario?.nivel || 'Bronce';
  const limiteUsuario = NIVEL_LIMITE[nivelUsuario] || 200;

  useEffect(() => {
    const cargar = async () => {
      setLoading(true);
      // Intentar query directo
      const { data, error } = await supabase.from('tandas').select('*, participantes(id)').order('created_at', { ascending: false });
      if (error) {
        // Si RLS bloquea, intentar con rpc o sin participantes
        console.log('Explorar error:', error);
        const { data: d2 } = await supabase.from('tandas').select('*').order('created_at', { ascending: false });
        setTandas(d2 || []);
      } else {
        setTandas(data || []);
      }
      setLoading(false);
    };
    cargar();
  }, []);

  const nivelOrdenUsuario = NIVEL_ORDEN[nivelUsuario] ?? 0;

  const tandasFiltradas = tandas.filter(t => {
    if (filtroMonto && t.monto !== filtroMonto) return false;
    if (filtroFrec) {
      const frec = t.frecuencia || 'Semanal';
      if (frec !== filtroFrec) return false;
    }
    if (filtroNivel) {
      const nivelTanda = t.nivel_minimo || 'Bronce';
      if (nivelTanda !== filtroNivel) return false;
    }
    return true;
  });

  const [solicitadas, setSolicitadas] = useState([]);
  const [misInscripciones, setMisInscripciones] = useState([]);

  useEffect(() => {
    const cargarInscripciones = async () => {
      const { data } = await supabase.from('participantes').select('tanda_id').eq('usuario_id', usuario.id);
      setMisInscripciones((data || []).map(p => p.tanda_id));
    };
    cargarInscripciones();
  }, []); // eslint-disable-line

  const perfilCompleto = usuario?.direccion_calle && usuario?.verificacion_identidad === 'aprobada';

  const solicitarUnirse = async (tanda) => {
    if (!perfilCompleto) {
      showToast('Completa tu dirección y verifica tu identidad en Mi Perfil antes de solicitar una tanda', 'error');
      return;
    }
    const nivelMinTanda = NIVEL_ORDEN[tanda.nivel_minimo || 'Bronce'] ?? 0;
    if (nivelOrdenUsuario < nivelMinTanda) {
      showToast(`Necesitas nivel ${tanda.nivel_minimo} o superior para esta tanda`, 'error');
      return;
    }
    // Verificar si ya es participante
    const { data: yaParticipa } = await supabase.from('participantes').select('id').eq('usuario_id', usuario.id).eq('tanda_id', tanda.id).maybeSingle();
    if (yaParticipa) { showToast('Ya estás en esta tanda', 'info'); return; }
    // Registrar solicitud
    await audit('solicitud_unirse', { tanda_id: tanda.id, tanda_nombre: tanda.nombre, monto: tanda.monto });
    setSolicitadas(prev => [...prev, tanda.id]);
    showToast('Solicitud enviada. El admin te confirmará pronto.', 'success');
  };

  return (
    <div style={{ minHeight: '100vh', background: C.gray50, fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
      <NavbarApp onMenuOpen={onMenu} titulo="Explorar" onHome={onHome} />
      <Toast msg={toast.msg} type={toast.type} />
      <div style={{ padding: '16px 16px 80px' }}>

        {/* Info nivel */}
        <div style={{ background: C.primaryLt, border: `1px solid ${C.primaryMd}`, borderRadius: 12, padding: '12px 14px', marginBottom: 16, display: 'flex', alignItems: 'center', gap: 10 }}>
          <NivelBadge nivel={nivelUsuario.split(' ')[0]} />
          <div style={{ fontSize: 13, color: C.text }}>Puedes unirte a tandas de hasta <strong>{fmt(limiteUsuario)}</strong></div>
        </div>

        {/* Filtro frecuencia */}
        <div style={{ marginBottom: 12 }}>
          <div style={{ fontSize: 11, fontWeight: 700, color: C.textLt, marginBottom: 8, textTransform: 'uppercase', letterSpacing: 0.5 }}>Frecuencia</div>
          <div style={{ display: 'flex', gap: 8 }}>
            {FRECUENCIAS.map(f => (
              <button key={f} onClick={() => setFiltroFrec(filtroFrec === f ? null : f)} style={{
                padding: '8px 14px', borderRadius: 99, border: 'none', cursor: 'pointer',
                background: filtroFrec === f ? C.primary : C.white,
                color: filtroFrec === f ? C.white : C.textMd,
                fontSize: 13, fontWeight: 700,
                border: filtroFrec === f ? 'none' : `1px solid ${C.gray200}`,
                fontFamily: "'Plus Jakarta Sans', sans-serif",
              }}>{f}</button>
            ))}
          </div>
        </div>

        {/* Filtro monto */}
        <div style={{ marginBottom: 20 }}>
          <div style={{ fontSize: 11, fontWeight: 700, color: C.textLt, marginBottom: 8, textTransform: 'uppercase', letterSpacing: 0.5 }}>Monto semanal</div>
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
            {MONTOS_FILTRO.map(m => {
              const bloqueado = m > limiteUsuario;
              return (
                <button key={m} onClick={() => bloqueado ? null : setFiltroMonto(filtroMonto === m ? null : m)} style={{
                  padding: '8px 14px', borderRadius: 99, border: 'none', cursor: bloqueado ? 'not-allowed' : 'pointer',
                  background: filtroMonto === m ? C.primary : bloqueado ? C.gray100 : C.white,
                  color: filtroMonto === m ? C.white : bloqueado ? C.gray400 : C.textMd,
                  fontSize: 13, fontWeight: 700, opacity: bloqueado ? 0.6 : 1,
                  border: filtroMonto === m ? 'none' : `1px solid ${C.gray200}`,
                  fontFamily: "'Plus Jakarta Sans', sans-serif",
                  position: 'relative',
                }}>
                  {bloqueado && '🔒 '}{fmt(m)}
                </button>
              );
            })}
          </div>
        </div>

        {/* Filtro nivel mínimo */}
        <div style={{ marginBottom: 20 }}>
          <div style={{ fontSize: 11, fontWeight: 700, color: C.textLt, marginBottom: 8, textTransform: 'uppercase', letterSpacing: 0.5 }}>Nivel mínimo</div>
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
            {NIVELES_FILTRO.map(n => (
              <button key={n} onClick={() => setFiltroNivel(filtroNivel === n ? null : n)} style={{
                padding: '8px 14px', borderRadius: 99, border: 'none', cursor: 'pointer',
                background: filtroNivel === n ? C.primary : C.white,
                color: filtroNivel === n ? C.white : C.textMd,
                fontSize: 13, fontWeight: 700,
                border: filtroNivel === n ? 'none' : `1px solid ${C.gray200}`,
                fontFamily: "'Plus Jakarta Sans', sans-serif",
              }}>{n}</button>
            ))}
          </div>
        </div>

        {/* Lista de tandas */}
        {loading && <div style={{ textAlign: 'center', padding: 40, color: C.textLt }}>Cargando tandas...</div>}

        {!loading && tandasFiltradas.length === 0 && (
          <Card style={{ textAlign: 'center', padding: 40 }}>
            <div style={{ fontSize: 40, marginBottom: 12 }}>🔍</div>
            <div style={{ fontSize: 16, fontWeight: 800, color: C.text, marginBottom: 6 }}>No hay tandas disponibles</div>
            <div style={{ fontSize: 13, color: C.textMd }}>Prueba cambiando los filtros o vuelve pronto.</div>
          </Card>
        )}

        {!loading && tandasFiltradas.map(tanda => {
          const numParticipantes = Array.isArray(tanda.participantes) ? tanda.participantes.length : (tanda.participantes_count || 0);
          const plazas = tanda.semanas - numParticipantes;
          const nivelMinTanda = NIVEL_ORDEN[tanda.nivel_minimo || 'Bronce'] ?? 0;
          const bloqueado = nivelOrdenUsuario < nivelMinTanda;
          return (
            <Card key={tanda.id} style={{ marginBottom: 12, opacity: bloqueado ? 0.6 : 1 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 10 }}>
                <div>
                  <div style={{ fontSize: 16, fontWeight: 900, color: C.text }}>{tanda.nombre}</div>
                  <div style={{ fontSize: 12, color: C.textMd, marginTop: 2 }}>{tanda.frecuencia || 'Semanal'} · {tanda.semanas} semanas · {tanda.nivel_minimo || 'Bronce'}+</div>
                </div>
                <div style={{ textAlign: 'right' }}>
                  <div style={{ fontSize: 18, fontWeight: 900, color: C.primary }}>{fmt(tanda.monto)}</div>
                  <div style={{ fontSize: 11, color: C.textLt }}>/{tanda.frecuencia === 'Mensual' ? 'mes' : tanda.frecuencia === 'Quincenal' ? 'quincena' : 'semana'}</div>
                </div>
              </div>

              <div style={{ display: 'flex', gap: 8, marginBottom: 12 }}>
                <div style={{ flex: 1, background: C.gray50, borderRadius: 8, padding: '8px 10px', textAlign: 'center' }}>
                  <div style={{ fontSize: 10, color: C.textLt }}>TANDA COMPLETA</div>
                  <div style={{ fontSize: 14, fontWeight: 800, color: C.text }}>{fmt(tanda.monto * tanda.semanas)}</div>
                </div>
                <div style={{ flex: 1, background: plazas > 0 ? C.successLt : C.dangerLt, borderRadius: 8, padding: '8px 10px', textAlign: 'center' }}>
                  <div style={{ fontSize: 10, color: plazas > 0 ? C.success : C.danger }}>PLAZAS</div>
                  <div style={{ fontSize: 14, fontWeight: 800, color: plazas > 0 ? C.success : C.danger }}>{plazas > 0 ? `${plazas} disponibles` : 'Llena'}</div>
                </div>
              </div>

              {misInscripciones.includes(tanda.id) ? (
                <div style={{ background: C.gray100, borderRadius: 10, padding: '12px 0', textAlign: 'center' }}>
                  <span style={{ fontSize: 14, fontWeight: 700, color: C.success }}>✅ Ya estás inscrito</span>
                </div>
              ) : bloqueado ? (
                <div style={{ background: C.warningLt, border: `1px solid #FDE68A`, borderRadius: 10, padding: '10px 14px', textAlign: 'center' }}>
                  <div style={{ fontSize: 12, fontWeight: 700, color: C.warning }}>🔒 Necesitas nivel {tanda.nivel_minimo || 'Bronce'} o superior</div>
                  <div style={{ fontSize: 11, color: C.textLt, marginTop: 2 }}>Tu nivel actual: {nivelUsuario}</div>
                </div>
              ) : plazas > 0 ? (
                solicitadas.includes(tanda.id) ? (
                  <Btn disabled variant="ghost" style={{ padding: '12px 0', fontSize: 14 }}>Solicitud enviada</Btn>
                ) : (
                  <Btn onClick={() => solicitarUnirse(tanda)} style={{ padding: '12px 0', fontSize: 14 }}>
                    Solicitar unirme
                  </Btn>
                )
              ) : (
                <Btn disabled style={{ padding: '12px 0', fontSize: 14 }}>Tanda llena</Btn>
              )}
            </Card>
          );
        })}
      </div>
    </div>
  );
}

// ─── MIS PAGOS ────────────────────────────────────────────
function MisPagos({ usuario, onMenu, onHome }) {
  const [pagos, setPagos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expandido, setExpandido] = useState(null); // tanda nombre expandida

  useEffect(() => {
    const cargar = async () => {
      setLoading(true);
      const { data: parts } = await supabase.from('participantes').select('id, turno, tandas(nombre, monto, frecuencia, semana_actual, semanas)').eq('usuario_id', usuario.id);
      if (!parts || parts.length === 0) { setPagos([]); setLoading(false); return; }
      const ids = parts.map(p => p.id);
      const { data: pagosData } = await supabase.from('pagos').select('*').in('participante_id', ids).order('semana', { ascending: false });
      const result = (pagosData || []).map(p => {
        const part = parts.find(pt => pt.id === p.participante_id);
        return { ...p, tanda: part?.tandas, turno: part?.turno };
      });
      setPagos(result);
      // Expandir la primera tanda por defecto
      if (result.length > 0) setExpandido(result[0].tanda?.nombre);
      setLoading(false);
    };
    cargar();
  }, []); // eslint-disable-line

  const estadoColors = { confirmado: { bg: '#D1FAE5', color: '#059669' }, en_revision: { bg: '#FEF3C7', color: '#D97706' }, rechazado: { bg: '#FEE2E2', color: '#DC2626' }, pendiente: { bg: '#F1F5F9', color: '#64748B' } };

  // Agrupar pagos por tanda
  const grupos = {};
  pagos.forEach(p => {
    const nombre = p.tanda?.nombre || 'Tanda';
    if (!grupos[nombre]) grupos[nombre] = { tanda: p.tanda, pagos: [] };
    grupos[nombre].pagos.push(p);
  });

  return (
    <div style={{ minHeight: '100vh', background: C.gray50, fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
      <NavbarApp onMenuOpen={onMenu} titulo="Mis pagos" onHome={onHome} />
      <div style={{ padding: '16px 16px 80px' }}>
        {loading && <div style={{ textAlign: 'center', padding: 40, color: C.textLt }}>Cargando...</div>}

        {!loading && pagos.length === 0 && (
          <Card style={{ textAlign: 'center', padding: 40 }}>
            <div style={{ fontSize: 40, marginBottom: 12 }}>💸</div>
            <div style={{ fontSize: 16, fontWeight: 800, color: C.text, marginBottom: 6 }}>Sin pagos registrados</div>
            <div style={{ fontSize: 13, color: C.textMd }}>Cuando hagas tu primer depósito aparecerá aquí.</div>
          </Card>
        )}

        {!loading && Object.entries(grupos).map(([nombre, grupo]) => {
          const isOpen = expandido === nombre;
          const confirmados = grupo.pagos.filter(p => p.pagado).length;
          const total = grupo.pagos.length;
          return (
            <Card key={nombre} style={{ marginBottom: 12, padding: 0, overflow: 'hidden' }}>
              {/* Header colapsable */}
              <div onClick={() => setExpandido(isOpen ? null : nombre)}
                style={{ display: 'flex', alignItems: 'center', padding: '16px 18px', cursor: 'pointer', gap: 12, background: isOpen ? '#F8FAFC' : '#fff' }}>
                <span style={{ fontSize: 14, color: C.textLt, transform: isOpen ? 'rotate(90deg)' : 'none', transition: 'transform 0.15s' }}>▶</span>
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: 15, fontWeight: 800, color: C.text }}>{nombre}</div>
                  <div style={{ fontSize: 12, color: C.textLt, marginTop: 2 }}>
                    {fmt(grupo.tanda?.monto)}/{grupo.tanda?.frecuencia || 'semana'} · {confirmados}/{total} pagos confirmados
                  </div>
                </div>
                <div style={{ background: confirmados === total ? '#D1FAE5' : '#FEF3C7', color: confirmados === total ? '#059669' : '#D97706', padding: '3px 10px', borderRadius: 99, fontSize: 11, fontWeight: 700 }}>
                  {confirmados}/{total}
                </div>
              </div>

              {/* Pagos expandidos */}
              {isOpen && (
                <div style={{ borderTop: `1px solid ${C.gray200}` }}>
                  {grupo.pagos.map(p => {
                    const estado = p.pagado ? 'confirmado' : p.estado_comprobante === 'rechazado' ? 'rechazado' : p.estado_comprobante === 'en_revision' ? 'en_revision' : 'pendiente';
                    const ec = estadoColors[estado];
                    return (
                      <div key={p.id} style={{ padding: '12px 18px', borderBottom: `1px solid ${C.gray100}` }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 4 }}>
                          <div style={{ fontSize: 13, fontWeight: 700, color: C.text }}>Semana {p.semana}</div>
                          <span style={{ background: ec.bg, color: ec.color, padding: '2px 8px', borderRadius: 99, fontSize: 10, fontWeight: 700 }}>
                            {estado === 'confirmado' ? 'Confirmado' : estado === 'en_revision' ? 'En revision' : estado === 'rechazado' ? 'Rechazado' : 'Pendiente'}
                          </span>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                          <div>
                            <span style={{ fontSize: 16, fontWeight: 900, color: C.primary }}>{fmt(grupo.tanda?.monto)}</span>
                            <span style={{ fontSize: 11, color: C.textLt, marginLeft: 8 }}>{new Date(p.created_at).toLocaleDateString('es-MX')}</span>
                          </div>
                          {p.comprobante_url && (
                            <a href={getComprobanteUrl(p.comprobante_url)} target="_blank" rel="noreferrer" style={{ fontSize: 11, color: C.primary, fontWeight: 700 }}>Ver comprobante</a>
                          )}
                        </div>
                        {estado === 'rechazado' && p.motivo_rechazo && (
                          <div style={{ background: '#FEF2F2', borderRadius: 8, padding: '6px 10px', marginTop: 6, fontSize: 11, color: C.danger }}>
                            Motivo: {p.motivo_rechazo}
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              )}
            </Card>
          );
        })}
      </div>
    </div>
  );
}

// ─── MIS TANDAS ────────────────────────────────────────────
function MisTandas({ usuario, onMenu, onHome, onExplorar }) {
  const [tandas, setTandas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [tandaSel, setTandaSel] = useState(null);
  const [notifs, setNotifs] = useState([]);
  const [mostrarNotifs, setMostrarNotifs] = useState(false);
  const [mostrarInstalar, setMostrarInstalar] = useState(false);

  // Detectar si la app no está instalada como PWA
  useEffect(() => {
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone;
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    const dismissed = localStorage.getItem('tmx_pwa_dismiss');
    if (!isStandalone && !dismissed && isMobile) setMostrarInstalar(true);
  }, []);

  useEffect(() => { cargarTandas(); cargarNotificaciones(); }, []); // eslint-disable-line

  const cargarTandas = async () => {
    setLoading(true);
    const { data } = await supabase.from('participantes').select('*, tandas(*), usuarios(nombre, codigo_ref)').eq('usuario_id', usuario.id);
    setTandas(data || []); setLoading(false);
  };

  const cargarNotificaciones = async () => {
    const { data } = await supabase.from('notificaciones').select('*').eq('usuario_id', usuario.id).order('created_at', { ascending: false }).limit(20);
    setNotifs(data || []);
  };

  const marcarLeidas = async () => {
    const noLeidas = notifs.filter(n => !n.leida);
    if (noLeidas.length > 0) {
      await supabase.from('notificaciones').update({ leida: true }).eq('usuario_id', usuario.id).eq('leida', false);
      setNotifs(prev => prev.map(n => ({ ...n, leida: true })));
    }
  };

  const notifsNoLeidas = notifs.filter(n => !n.leida).length;

  if (tandaSel) return <DetalleTanda participante={tandaSel} onBack={() => { setTandaSel(null); cargarTandas(); }} onMenu={onMenu} />;

  const perfilIncompleto = !usuario.curp || !usuario.direccion_calle;

  return (
    <div style={{ minHeight: '100vh', background: C.gray50, fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
      <NavbarApp onMenuOpen={onMenu} onHome={onHome} notificaciones={notifsNoLeidas} onNotificaciones={() => { setMostrarNotifs(true); marcarLeidas(); }} />

      {/* Modal notificaciones */}
      {mostrarNotifs && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', zIndex: 500, display: 'flex', alignItems: 'flex-start', justifyContent: 'center', paddingTop: 72 }}>
          <div style={{ background: C.white, borderRadius: 16, width: '90%', maxWidth: 400, maxHeight: '70vh', overflowY: 'auto', boxShadow: '0 8px 32px rgba(0,0,0,0.2)' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px 18px', borderBottom: `1px solid ${C.gray200}` }}>
              <div style={{ fontSize: 16, fontWeight: 900, color: C.text }}>Notificaciones</div>
              <button onClick={() => setMostrarNotifs(false)} style={{ background: 'none', border: 'none', fontSize: 20, cursor: 'pointer', color: C.textLt }}>x</button>
            </div>
            {notifs.length === 0 ? (
              <div style={{ padding: 40, textAlign: 'center', color: C.textLt, fontSize: 13 }}>Sin notificaciones</div>
            ) : notifs.map(n => (
              <div key={n.id} style={{ padding: '14px 18px', borderBottom: `1px solid ${C.gray100}`, background: n.leida ? 'transparent' : C.primaryLt }}>
                <div style={{ fontSize: 14, fontWeight: 700, color: C.text, marginBottom: 4 }}>{n.titulo}</div>
                <div style={{ fontSize: 13, color: C.textMd, lineHeight: 1.5 }}>{n.mensaje}</div>
                <div style={{ fontSize: 11, color: C.textLt, marginTop: 6 }}>{new Date(n.created_at).toLocaleString('es-MX')}</div>
              </div>
            ))}
          </div>
        </div>
      )}
      <div style={{ padding: '16px 16px 80px' }}>

        {/* Banner perfil incompleto */}
        {perfilIncompleto && (
          <div style={{ background: C.warningLt, border: `1px solid #FDE68A`, borderRadius: 14, padding: '14px 16px', marginBottom: 16, display: 'flex', gap: 12, alignItems: 'flex-start' }}>
            <div style={{ fontSize: 24, flexShrink: 0 }}>⚠️</div>
            <div>
              <div style={{ fontSize: 13, fontWeight: 800, color: C.warning, marginBottom: 4 }}>Completa tu perfil para unirte a una tanda</div>
              <div style={{ fontSize: 12, color: C.textMd, lineHeight: 1.5 }}>Necesitamos tu dirección, CURP e INE para verificar tu identidad antes de aceptarte en una tanda.</div>
            </div>
          </div>
        )}

        {/* Card principal */}
        <div style={{ background: `linear-gradient(135deg, ${C.primary}, #0EA5E9)`, borderRadius: 16, padding: '20px 16px', marginBottom: 20, color: C.white }}>
          <div style={{ fontSize: 20, fontWeight: 900, marginBottom: 8 }}>Hola, {usuario.nombre} 👋</div>
          <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginBottom: 16 }}>
            <NivelBadge nivel={usuario.nivel} />
            <span style={{ fontSize: 12, color: 'rgba(255,255,255,0.8)' }}>{usuario.tandas_completadas} tandas completadas</span>
          </div>
          <div style={{ display: 'flex', gap: 24 }}>
            <div><div style={{ fontSize: 13, opacity: 0.8, marginBottom: 4 }}>Tandas activas</div><div style={{ fontSize: 26, fontWeight: 900 }}>{tandas.filter(t => t.tandas?.estado === 'activa').length}</div></div>
            <div><div style={{ fontSize: 13, opacity: 0.8, marginBottom: 4 }}>Puntos de reputacion</div><div style={{ fontSize: 26, fontWeight: 900 }}>{usuario.puntos || 0}<span style={{ fontSize: 15 }}> pts</span></div></div>
          </div>
        </div>

        {/* Banner instalar PWA */}
        {mostrarInstalar && (() => {
          const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
          const isAndroid = /Android/.test(navigator.userAgent);
          return (
            <div style={{ background: '#fff', border: `1.5px solid ${C.primaryMd}`, borderRadius: 14, padding: '16px', marginBottom: 16, position: 'relative' }}>
              <button onClick={() => { setMostrarInstalar(false); localStorage.setItem('tmx_pwa_dismiss', '1'); }}
                style={{ position: 'absolute', top: 10, right: 12, background: 'none', border: 'none', fontSize: 18, color: C.textLt, cursor: 'pointer' }}>x</button>
              <div style={{ fontSize: 14, fontWeight: 800, color: C.text, marginBottom: 8 }}>📲 Instala TandaClick en tu celular</div>
              <div style={{ fontSize: 13, color: C.textMd, lineHeight: 1.7, marginBottom: 4 }}>
                Accede más rápido y recibe notificaciones.
              </div>
              {isIOS ? (
                <div style={{ background: C.gray50, borderRadius: 10, padding: '12px 14px', marginTop: 10 }}>
                  <div style={{ fontSize: 12, fontWeight: 700, color: C.text, marginBottom: 8 }}>Instrucciones para iPhone:</div>
                  <div style={{ fontSize: 12, color: C.textMd, lineHeight: 1.8 }}>
                    1. Toca el ícono de <strong>compartir</strong> <span style={{ fontSize: 16 }}>⬆️</span><br/>
                    2. Baja y toca <strong>"Agregar a Inicio"</strong><br/>
                    3. Asegúrate que <strong>"Abrir como app web"</strong> esté activado<br/>
                    4. Toca <strong>"Agregar"</strong>
                  </div>
                </div>
              ) : isAndroid ? (
                <div style={{ background: C.gray50, borderRadius: 10, padding: '12px 14px', marginTop: 10 }}>
                  <div style={{ fontSize: 12, fontWeight: 700, color: C.text, marginBottom: 8 }}>Instrucciones para Android:</div>
                  <div style={{ fontSize: 12, color: C.textMd, lineHeight: 1.8 }}>
                    1. Toca <strong>"Instalar"</strong> en el banner que aparece<br/>
                    2. O toca los <strong>tres puntos ⋮</strong> arriba a la derecha<br/>
                    3. Selecciona <strong>"Agregar a pantalla de inicio"</strong>
                  </div>
                </div>
              ) : (
                <div style={{ background: C.gray50, borderRadius: 10, padding: '12px 14px', marginTop: 10 }}>
                  <div style={{ fontSize: 12, color: C.textMd, lineHeight: 1.8 }}>
                    Abre esta página en el navegador de tu celular y agrégala a la pantalla de inicio.
                  </div>
                </div>
              )}
            </div>
          );
        })()}

        <div style={{ fontSize: 11, fontWeight: 800, color: C.textLt, letterSpacing: 1, marginBottom: 12, textTransform: 'uppercase' }}>Mis tandas</div>
        {loading && <div style={{ textAlign: 'center', padding: 40, color: C.textLt }}>Cargando...</div>}
        {!loading && tandas.length === 0 && (
          <Card style={{ textAlign: 'center', padding: 40 }}>
            <div style={{ fontSize: 48, marginBottom: 12 }}>🔍</div>
            <div style={{ fontSize: 17, fontWeight: 800, color: C.text, marginBottom: 8 }}>Aún no tienes tandas</div>
            <div style={{ fontSize: 13, color: C.textMd, lineHeight: 1.7, marginBottom: 20 }}>Explora las tandas disponibles y encuentra la que se acomode a tu medida.</div>
            <Btn onClick={onExplorar} style={{ padding: '14px 0', fontSize: 15 }}>
              Explorar tandas
            </Btn>
          </Card>
        )}
        {tandas.map(p => {
          const estado = p.tandas?.estado || 'pendiente';
          const estadoColors = { activa: { bg: C.successLt, color: C.success }, pendiente: { bg: C.warningLt, color: C.warning }, terminada: { bg: C.gray100, color: C.textLt } };
          const ec = estadoColors[estado] || estadoColors.pendiente;
          return (
          <Card key={p.id} onClick={() => setTandaSel(p)} style={{ marginBottom: 12 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 10 }}>
              <div>
                <div style={{ fontSize: 17, fontWeight: 800, color: C.text }}>{p.tandas?.nombre}</div>
                <div style={{ fontSize: 13, color: C.textMd, marginTop: 4 }}>{fmt(p.tandas?.monto)}/{({ 'semanal': 'semana', 'quincenal': 'quincena', 'mensual': 'mes' })[(p.tandas?.frecuencia || 'Semanal').toLowerCase()] || 'semana'} · {p.turno ? `Turno #${p.turno}` : 'Sin turno'}</div>
              </div>
              <span style={{ background: ec.bg, color: ec.color, borderRadius: 99, padding: '3px 10px', fontSize: 10, fontWeight: 700 }}>{estado.charAt(0).toUpperCase() + estado.slice(1)}</span>
            </div>
            <div style={{ background: C.gray100, borderRadius: 99, height: 6, overflow: 'hidden' }}>
              <div style={{ width: `${Math.min(100, ((p.tandas?.semana_actual || 0) / (p.tandas?.semanas || 1)) * 100)}%`, height: '100%', background: C.primary, borderRadius: 99 }} />
            </div>
            <div style={{ fontSize: 13, color: C.textLt, marginTop: 8 }}>Semana {p.tandas?.semana_actual} de {p.tandas?.semanas} · Tanda: {fmt((p.tandas?.monto || 0) * (p.tandas?.semanas || 0))}</div>
          </Card>
          );
        })}

        {/* Mini FAQ al final */}
        <MiniFaq />
        <div style={{ padding: '32px 0 8px' }}>
          <TablaNiveles />
        </div>
      </div>
    </div>
  );
}


export { MisTandas, MenuHamburguesa, NavbarApp, Proximamente, PreguntasFrecuentesApp, Explorar, MisPagos };
